module.exports = __webpack_public_path__ + "img/footer-image.0f49ae69.png";